import {Component, EventEmitter, Input, Output} from "@angular/core";
import {IDropdownSettings} from "ng-multiselect-dropdown";


@Component({
    selector: "app-multi-select",
    templateUrl: "./multi-select-component.html"
})

export class MultiSelectComponent {

    public dropdownSettings: IDropdownSettings =  {
        singleSelection: false,
        idField: "id",
        textField: "text",
        selectAllText: "Marcar Todos",
        unSelectAllText: "Desmarcar Todos",
        itemsShowLimit: 3,
        allowSearchFilter: true,
        maxHeight: 150
    };

    @Input()
    public placeholder = "";

    @Input()
    public dataList: DataList[];
    @Input()
    public selectedItems: DataList[] = [];
    @Input()
    public disabled  = false;

    @Output()
    public getItems = new EventEmitter<DataList[]>();

    getSelectedItems() {
        this.getItems.emit(this.selectedItems);
    }

    clearData() {
        this.selectedItems = [];
    }
}

export interface DataList {
    id: number;
    text: string;
}

